import React from 'react';
import HeadGraphs from './components/HeadGraphs';
import SubHeadGraphs from './components/subHeadGraphs';
import Bottom from './components/bottom';

const FinancialDashboard = () => {

  return (
    <>
    <HeadGraphs />
    <SubHeadGraphs />
    <Bottom />
    </>
  );
};

export default FinancialDashboard;